import { render, staticRenderFns } from "./IbExpandPanel.vue?vue&type=template&id=037161ea&scoped=true"
import script from "./IbExpandPanel.vue?vue&type=script&lang=js"
export * from "./IbExpandPanel.vue?vue&type=script&lang=js"
import style0 from "./IbExpandPanel.vue?vue&type=style&index=0&id=037161ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037161ea",
  null
  
)

export default component.exports